module.exports = __webpack_public_path__ + "static/media/ibacos_innovation.c4160482.svg";